import styled from 'styled-components';

import Link from 'components/link';

import theme from './theme';

export const StyledLink = styled(Link)`
  color: ${theme.styledLinkColor};
  font-size: 0.875rem;
  text-decoration: underline;
  margin-top: 2rem;
  margin-bottom: 3rem;
  cursor: pointer;
  text-align: center;
`;

export const Title = styled.h3`
  color: ${theme.titleColor};
  font-family: ${Styles.fontFamily.base};
  text-align: center;
  text-transform: ${Styles.textTransform.headlines};
  font-weight: ${Styles.fontWeight.heavy};
`;
